module.exports = __webpack_public_path__ + "img/279.b977acfb.jpg";